import { takeLatest, call, put } from "redux-saga/effects";
import {
  partnerLogoUploaded,
  PARTNER_LOGO_UPLOAD_REQUEST,
  partnerLogoUploadError,
} from "../../actions/partners";
import uploadLogo from "../../../../../backend/oncall/administration/partners/upload-logo";

const requestUpdate = function*(action) {
  try {
    yield call(
      uploadLogo,
      parseInt(action.payload.partnerId, 10),
      action.payload.formData.file,
    );
    yield put(partnerLogoUploaded(action.payload.formData.file));
  } catch (error) {
    yield put(partnerLogoUploadError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(PARTNER_LOGO_UPLOAD_REQUEST, requestUpdate);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/partners/request-upload-logo.js